// extracted by mini-css-extract-plugin
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--f6713";
export var item = "Breadcrumbs-module--item--364a7";
export var link = "Breadcrumbs-module--link--6aad1";
export var list = "Breadcrumbs-module--list--c599c";